import { useCallback, useState } from "react";
import { casinoResolve } from "../redux/casinoSlice";
import { getBetGameId } from "../utils/casinoHelpers";
import {
  getRouletteRotationForPocketIndex,
  ROULETTE_POCKETS,
} from "../utils/roulettePockets";

export const BOND_SPIN_WHEEL_DURATION_MS = 5000;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function useBondSpinPlay(dispatch, userId) {
  const [isSpinPlaying, setIsSpinPlaying] = useState(false);
  const [wheelRotationDeg, setWheelRotationDeg] = useState(null);
  const [wheelSettleMs, setWheelSettleMs] = useState(900);
  const [spinGameResult, setSpinGameResult] = useState(null);
  const [spinResultModal, setSpinResultModal] = useState(null);

  const resetWheel = useCallback(() => {
    setWheelRotationDeg(null);
    setWheelSettleMs(900);
    setSpinGameResult(null);
  }, []);

  const playSpinBet = useCallback(
    async (bet) => {
      if (!bet?._id || !userId || isSpinPlaying) return;

      setIsSpinPlaying(true);
      resetWheel();

      const pocketIndex = Math.floor(Math.random() * ROULETTE_POCKETS.length);
      const outcome = ROULETTE_POCKETS[pocketIndex];
      const finalRotation = getRouletteRotationForPocketIndex(pocketIndex, 10);

      setWheelSettleMs(0);
      setWheelRotationDeg(0);
      await delay(32);

      setWheelSettleMs(BOND_SPIN_WHEEL_DURATION_MS);
      setWheelRotationDeg(finalRotation);

      await delay(BOND_SPIN_WHEEL_DURATION_MS + 120);

      setSpinGameResult(outcome);

      try {
        const res = await dispatch(
          casinoResolve({
            gameId: getBetGameId(bet) || bet.game?._id,
            bettorId: userId,
            betId: bet._id,
            gameResult: outcome,
          })
        ).unwrap();

        const serverBet = res?.bet;
        const won = serverBet?.status === "Won";

        setSpinResultModal({
          message: won ? "You won!" : "You lost",
          tone: won ? "success" : "danger",
          bet,
          gameResult: outcome,
          winAmount: won ? Number(serverBet?.bettorWinning || 0) : null,
          betAmount: Number(bet.betAmount || 0),
          betId: bet._id,
        });
      } catch (error) {
        resetWheel();
        throw error;
      } finally {
        setIsSpinPlaying(false);
      }
    },
    [dispatch, userId, isSpinPlaying, resetWheel]
  );

  const closeSpinResultModal = useCallback(() => {
    const betId = spinResultModal?.betId || spinResultModal?.bet?._id || null;
    setSpinResultModal(null);
    resetWheel();
    return betId;
  }, [spinResultModal, resetWheel]);

  return {
    isSpinPlaying,
    wheelRotationDeg,
    wheelSettleMs,
    spinGameResult,
    spinResultModal,
    playSpinBet,
    closeSpinResultModal,
  };
}
